import { CSSProperties } from "react";

/**
 * This helper function transform JavaScript objects to valid CSS string.
 * See tests for examples.
 * @param object JavaScript object to transform to CSS
 * @returns CSS string
 */
export const objectToCssProperties = (object: CSSProperties) =>
  Object.entries(object)
    .map(
      ([property, value]) =>
        `${property.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`)}:${value}`,
    )
    .join(";");
